import React from 'react';
import logo from '../logo.jpeg'; 

function HeroSection() {
  return (
    <main id="home" className="max-w-7xl mx-auto flex flex-col-reverse md:flex-row items-center justify-between px-6 md:px-16 lg:px-24 py-16 md:py-28 gap-12 md:gap-16">
      <div className="md:w-3/5 flex flex-col items-start space-y-8 z-10">
        <h1 className="text-5xl md:text-7xl font-serif font-bold leading-[1.1] text-deep-charcoal">
          Authentic Balance & <br /> <span className="text-ocean-teal italic">Organic Growth.</span>
        </h1>
        <p className="text-lg md:text-xl text-deep-charcoal/70 leading-relaxed max-w-xl border-l-4 border-ocean-teal/40 pl-6">
          A personalized journey toward well-being, guided by ancient wisdom and modern psychology. 
        </p>
        <div className="flex flex-wrap gap-4">
          <a href="#booking" className="bg-ocean-teal text-white px-8 md:px-10 py-4 rounded-full font-bold text-lg hover:bg-ocean-teal/90 transition-all shadow-xl hover:shadow-ocean-teal/30">
            Get Started
          </a>
          <a href="#about" className="border-2 border-deep-charcoal/10 px-8 md:px-10 py-4 rounded-full font-bold text-lg hover:bg-deep-charcoal hover:text-white hover:border-transparent transition-all">
            My Story
          </a>
        </div>
      </div>

      <div className="md:w-2/5 relative w-full max-w-sm md:max-w-md mx-auto">
        <div className="absolute -inset-6 bg-gradient-to-tr from-ocean-teal/20 to-transparent rounded-[4rem] blur-2xl"></div>
        <div className="relative bg-white p-4 md:p-6 rounded-[3rem] shadow-2xl rotate-2 hover:rotate-0 transition-transform duration-700 ease-out">
          <img src={logo} alt="Parinita Dutta Roy Logo" className="w-full h-auto rounded-[2rem] object-cover" loading="lazy" />
        </div>
      </div>
    </main>
  );
}

export default HeroSection;